import React from 'react'

const StopRecordIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" fill="url(#pattern0_201_91)"/>
      <defs>
        <pattern id="pattern0_201_91" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_201_91" transform="scale(0.03125)"/>
        </pattern>
        <image id="image0_201_91" width="32" height="32" preserveAspectRatio="none" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAfFJREFUWIXFlzFrFEEYhp9viCTREG2EiI0GLmBhVPwFps1vUAQ7/4AWQRDEQkSsBEHBSn9BtFKxSZqAEbFRuEhEECs1d4IRfSw2K2fwsnO5XPbtdmfme97Z2Z15N8iUOg7MAjPACeAIcGCj+QvwHlgGngHzEbGWW7sKPKXeV9vmq63eUxv9gEfVm+rPHsCbta7eUEd6hTfU132AN2tRPZQLP6V+3kF4qQ/qdM7MBwHvNDHRDT6iLg8QXmpJHS25qcPDNYrPa9A6DVwuL2Jj9lPAG2BoFwwAtIBGRHwqgZcq4G+BB8DvTEACzgNTXdrHgCvARdRxqzeZuUzwX6lzFTVb6lii2F73VtXr1UDGmH3AbKLY2+vSTGJ33vxumk7A0RoNTCZgvEYD+1N1n8EqAd9q5H9NwEqNBpqJIkbVpVeJIsPVpacJmAe+V3SMbRSvGtMGngxFxJr6CLiwReez6i96O4zOVfR5GBGt8jhuUBzHezIB/WodOBYRzQQQEe+A27sEB7gVEc1/7lhEssW+wlaeFtTh/9pSJ9TVAcI/qoe3fDbqtEV63WmtqsezFkg9qL7YQfiC3eL4FiaG1asW0Wm7+qFet9uaZxqZUO/0aKSl3lUnq+pn73DqGEV+PAOcpAgynb/nK8BL4DnwOCJaOXX/AK9Wrgab4vRDAAAAAElFTkSuQmCC"/>
      </defs>
    </svg>
  )
}

export default StopRecordIcon
